import { get, isEmpty } from 'lodash';
import { TRANSFER_TYPE_ENUM } from 'Views/booking/constants';
import { transformMinutesInHours } from 'Components/widgets/transport-details/transportUtils';

const getTransferLabelKey = (directionType?: TransferDirectionType | null) => {
  switch (directionType) {
    case TRANSFER_TYPE_ENUM.ROUND_TRIP:
      return 'common.transport.transfer.introduction';

    case TRANSFER_TYPE_ENUM.INBOUND:
      return 'common.transport.transfer.inbound';

    case TRANSFER_TYPE_ENUM.OUTBOUND:
      return 'common.transport.transfer.outbound';

    default:
      return 'common.transport.transfer.default';
  }
};

function getTransferOption(transfer: UpsellTransfer): TransferOption {
  const durationInMinutes = get(transfer, 'productInfo.durationInMinutes');
  const durationInHours = durationInMinutes ? transformMinutesInHours(durationInMinutes) : '';
  const label = get(transfer, 'productInfo.label');
  return {
    value: get(transfer, 'pricingInfo.id'),
    label: `${label}${durationInHours ? `: ${durationInHours}` : ''}`,
  };
}

function getCtaType(
  selectedTransfert: UpsellTransfer | null | undefined,
  addedTransfer: UpsellTransfer | null | undefined,
): 'add' | 'disabled' | 'remove' {
  if (!selectedTransfert) {
    return 'disabled';
  }

  return addedTransfer ? 'remove' : 'add';
}

const getTransferOptions = (
  transfers: ReadonlyArray<UpsellTransfer>,
  chooseTransfer: string,
): Array<TransferOption> => {
  if (isEmpty(transfers)) {
    return [];
  }

  const emptyTransferOption: TransferOption = {
    value: '',
    label: chooseTransfer,
  };
  return transfers.length === 1
    ? transfers.map(getTransferOption)
    : [emptyTransferOption].concat(transfers.map(getTransferOption));
};

const getTransferFromValue = (
  transfers: ReadonlyArray<UpsellTransfer>,
  value: string,
): UpsellTransfer | null => {
  return (transfers || []).find((transfer) => transfer.pricingInfo.id === value) || null;
};

const getTransfersWithLabel = (transfers: ReadonlyArray<UpsellTransfer>): Array<UpsellTransfer> => {
  return (transfers || []).filter((transfer) => get(transfer, 'productInfo.label'));
};

const getSelectedTransfer = (
  availableTransfers: ReadonlyArray<UpsellTransfer>,
  selectedTransfers: ReadonlyArray<UpsellTransfer>,
): UpsellTransfer | null => {
  const validTransfers = getTransfersWithLabel(availableTransfers);
  let selectedTransfer = null;

  if (!isEmpty(selectedTransfers)) {
    [selectedTransfer] = selectedTransfers;
  } else if (validTransfers.length === 1) {
    [selectedTransfer] = validTransfers;
  }

  return selectedTransfer;
};

const getInitiallySelectedTransfer = ({
  isBE,
  addedTransfer,
  selectedTransfers,
  availableTransfers,
}: {
  isBE: boolean;
  addedTransfer: UpsellTransfer | null;
  selectedTransfers: ReadonlyArray<UpsellTransfer>;
  availableTransfers: ReadonlyArray<UpsellTransfer>;
}) => {
  if (isBE) {
    if (availableTransfers.length === 1) {
      return addedTransfer || availableTransfers[0];
    }

    return addedTransfer || null;
  }

  return getSelectedTransfer(selectedTransfers, availableTransfers);
};

export {
  getCtaType,
  getTransferLabelKey,
  getTransferOptions,
  getTransferFromValue,
  getTransfersWithLabel,
  getSelectedTransfer,
  getInitiallySelectedTransfer,
};
